<footer class="footer mt-2 mt-md-5 pt-0">
  <div class="footer-bottom bg-light">
    <div class="container">
      <div class="row">
        <div class="col-md-6 ">
          <div class="d-flex justify-content-md-start justify-content-center">
            <ul class="list-unstyled d-flex mb-0">
              <li><a role="button" (click)="handlePrivacyActionClick()">Privacy Policy</a></li>
              <li><a role="button" (click)="handleAboutClick()">About Manzoul</a></li>
              <li><a role="button" (click)="handleTeamClick()">Team</a></li>
              <li><a role="button" (click)="handleContactUsClick()">Contact</a></li>
            </ul>
          </div>
        </div>
        <div class="col-md-6 text-center text-md-right mt-4 mt-md-0">
          <p class="mb-0"> &copy;Copyright <span id="copyright">
              <script>document.getElementById('copyright').appendChild(document.createTextNode(new Date().getFullYear()))</script>
            </span> <a href="#"> Manzoul </a> All Rights Reserved </p>
        </div>
      </div>
    </div>
  </div>
</footer>

<app-modal #privacyModal [modalConfig]="modalConfig">
  <div class="form-row">
    <div class="form-group col-sm-12 mb-0">
      <div class=WordSection1>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>Manzoul Privacy
            Statement</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>Last Updated:
            01/06/2023.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>At Manzoul, we
            are committed to protecting and
            respecting your privacy. This Privacy Statement (together with our terms and
            conditions and any other policies referred to in it) outlines what information
            we gather about you, what and how we use that information, the lawful basis on
            which that information is used and who we give that information to. It also
            sets out your rights and our obligations in relation to your information and
            who you can contact for more information or queries.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><b><span style='font-size:12.0pt'>Information
              Collection:</span></b></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>We may collect
            personal information, such as names,
            addresses, email addresses, phone numbers, education and employment history
            when voluntarily provided by our customers. Additionally, we may automatically
            collect certain information when you visit our website, such as IP addresses,
            browser type, and pages accessed. We may also keep record of your activities
            such as posting material, sending messages, giving reviews, and details of
            transactions and projects you carry out via our website.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>We may ask you
            for information when you report an
            issue or concern or we have or receive a complaint or query about you (whether
            or not a formal dispute is raised).</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>We may keep a
            record of correspondence between you and
            us. We may ask you to complete surveys that we use for research purposes,
            although you do not have to respond to them.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>We sometimes
            supplement the information that you
            provide with information received from third parties. For instance, credit
            reference agencies, search information providers, PayPal, other companies
            (subject to their privacy policies and applicable law), and from other accounts
            we have reason to believe you control (whether in part or in whole).</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><b><span style='font-size:12.0pt'>Use of
              Information:</span></b></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>We use the
            collected information for the following
            purposes:</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>To provide our
            products and services to customers.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>To communicate
            with customers regarding their
            inquiries, orders, or other requests.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>To improve our
            website, products, and services.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>To analyse trends
            and gather demographic information.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>To comply with
            applicable laws and regulations.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><b><span style='font-size:12.0pt'>Information
              Sharing:</span></b></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>We do not sell,
            trade, or rent our customers' personal
            information to third parties. However, we may share information with trusted
            partners or service providers who assist us in operating our business, as long
            as they agree to keep the information confidential and use it solely for the
            purposes outlined in this Privacy Statement.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><b><span
              style='font-size:12.0pt'>Children</span></b></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>We understand the
            importance of protecting children's
            privacy. Our website is not designed for, or intentionally targeted at,
            children. It is not our policy to intentionally collect or store information
            about children.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><b><span style='font-size:12.0pt'>Cookies and
              Tracking Technologies:</span></b></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>We may use
            cookies and similar tracking technologies
            on our website to enhance user experience, analyse usage patterns, and
            customize content. Users have the option to modify their browser settings to
            reject cookies, although this may affect certain features or functionality of
            our website.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><b><span style='font-size:12.0pt'>The legal
              grounds we use for processing personal
              information</span></b></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>We are not
            allowed to process personal information if
            we do not have a valid legal ground. Therefore, we will only process your
            personal information for the purposes outlined above because:</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>of our legitimate
            interests in the performance of
            activities that form part of the operation of our business;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>of our legitimate
            interests in the effective and
            lawful operation of our business so long as such interests are not outweighed
            by your interests or fundamental rights and freedoms;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>of the legal and
            regulatory obligations that we are
            subject to, such as keeping records for tax purposes or providing information
            to a public body or law enforcement agency; or</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>the information
            is required in order to carry out the
            activities that form part of the operation of our business (e.g. the processing
            is necessary to perform our contractual obligations towards you).</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><b><span
              style='font-size:12.0pt'>Unsubscribe</span></b></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>We may, from time
            to time, e-mail or post you
            information to make you aware of our other similar products and services which
            may be of interest to you. If you do not wish to receive emails or post from us
            for these purposes, or if you want to be removed from our electronic mailing
            list you can either select “unsubscribe” from any of the marketing emails that
            we send or alternatively contact us.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><b><span style='font-size:12.0pt'>Links to
              Third-Party Websites:</span></b></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>Our website may
            contain links to third-party websites
            that are not operated or controlled by Manzoul. We are not responsible for the
            privacy practices or content of these external websites. We encourage users to
            review the privacy statements of those websites before providing any personal
            information.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><b><span style='font-size:12.0pt'>Protection of
              your personal data</span></b></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>At Manzoul, all
            personnel accessing personal
            information must comply with the internal rules and processes in relation to
            the processing of personal data to protect them and ensure the confidentiality
            of such information.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><b><span style='font-size:12.0pt'>Updates to
              this Privacy Statement:</span></b></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>We may update
            this Privacy Statement from time to time
            to reflect changes in our business practices or legal requirements. The updated
            version will be posted on our website, and we encourage users to review it
            periodically.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><b><span style='font-size:12.0pt'>Contact
              Us:</span></b></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>If you have any
            questions, concerns, or requests
            regarding this Privacy Statement or the handling of your personal information,
            please contact us at Welcome@Manzoul.com.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>We have also
            implemented adequate technical and
            organisational measures to protect personal data against unauthorised,
            accidental or unlawful destruction, loss, alteration, misuse, disclosure or
            access and against all other unlawful forms of processing. These security
            measures have been implemented taking into account the state of the art of the
            technology, their cost of implementation, the risks presented by the processing
            and the nature of the personal information, with particular care for sensitive
            information.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>Although we use
            appropriate security measures once we
            have received your personal data, the transmission of data over the internet
            (including by e-mail) is never completely secure. We endeavour to protect
            personal data, but we cannot guarantee the security of data transmitted to us
            or by us.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><b><span style='font-size:12.0pt'>How long we
              keep your information for</span></b></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>We will hold your
            personal data on our systems for the
            longest of the following periods: (1) as long as is necessary for the relevant
            activity (which is typically 7 years); (2) any retention period that is
            required by law or regulation; or (3) the end of the period in which litigation
            or investigations might arise in respect of our activities.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><b><span style='font-size:12.0pt'>Your
              rights</span></b></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>Your
            Rights:</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>As a customer of
            Manzoul, you have certain rights
            regarding your personal information:</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>Right to
            rectification: You can request corrections or
            updates to your personal information if it is inaccurate or incomplete.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>Right to erasure:
            You have the right to request the
            deletion of your personal information under certain circumstances.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>Right to object:
            You can object to the processing of
            your personal information based on legitimate interests.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>Right to restrict
            processing: You have the right to
            request the restriction of processing your personal information in certain
            situations.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>Right to data
            portability: You can request to receive
            a copy of your personal information in a structured, commonly used, and
            machine-readable format.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>Right to withdraw
            consent: If we rely on your consent
            for the processing of your personal information, you have the right to withdraw
            that consent at any time.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>To exercise any
            of your rights, or if you have any
            other questions about our use of your personal data, please contact us at
            Welcome@Manzoul.com.</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

        <p class=MsoNormal style='margin-bottom:0in;line-height:normal'><span style='font-size:12.0pt'>&nbsp;</span></p>

      </div>
    </div>
  </div>
</app-modal>

<app-modal #contactusModal [modalConfig]="contactUsModalConfig">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="section-title-02 text-center" *ngIf="contactUsForm">
          <h2>Let’s Get In Touch!</h2>
          <p>If you have any query please reach out to us.</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0"></div>
      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <div class="feature-info feature-info-border p-4 text-center">
          <div class="feature-info-icon mb-3">
            <i class="flaticon-contact fa-flip-horizontal"></i>
          </div>
          <div class="feature-info-content">
            <h5 class="text-black">Phone Number</h5>
            <span class="d-block" [tabIndex]="0">+442082525060</span>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 mb-4 mb-md-0">
        <div class="feature-info feature-info-border p-4 text-center">
          <div class="feature-info-icon mb-3">
            <i class="flaticon-approval"></i>
          </div>
          <div class="feature-info-content">
            <h5 class="text-black">Email</h5>
            <span class="d-block">info@manzoul.com</span>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0"></div>
    </div>
    <div class="space-pt"></div>
    <form [formGroup]="contactUsForm" class="needs-validation" novalidate *ngIf="contactUsForm">
      <div class="form-row">
        <div class="form-group col-md-6">
          <input type="text" class="form-control" id="Name" placeholder="Enter Your Name" formControlName="name">
          <div class="text-danger mt-1" *ngIf="canShowValidation('name')">
            {{ getValidationMessage("name") }}
          </div>
        </div>
        <div class="form-group col-md-6">
          <input type="text" class="form-control" id="Subject" placeholder="Subject" formControlName="subject">
          <div class="text-danger mt-1" *ngIf="canShowValidation('subject')">
            {{ getValidationMessage("subject") }}
          </div>
        </div>
        <div class="form-group col-md-6">
          <input type="text" class="form-control" id="email" placeholder="Enter Your Email Address"
            formControlName="email">
          <div class="text-danger mt-1" *ngIf="canShowValidation('email')">
            {{ getValidationMessage("email") }}
          </div>
        </div>
        <div class="form-group col-md-6">
          <input class="form-control" id="phone" placeholder="Enter Your Phone Number" formControlName="phoneNumber">
          <div class="text-danger mt-1" *ngIf="canShowValidation('phoneNumber')">
            {{ getValidationMessage("phoneNumber") }}
          </div>
        </div>
        <div class="form-group col-12 mb-0">
          <textarea rows="5" class="form-control" id="details" placeholder="Details"
            formControlName="details"></textarea>
          <div class="text-danger mt-1" *ngIf="canShowValidation('details')">
            {{ getValidationMessage("details") }}
          </div>
        </div>
        <div class="col-12 text-center mt-4">
          <a class="btn btn-primary" (click)="handleContactUsSubmission()">Send your message</a>
        </div>
      </div>
    </form>
  </div>
</app-modal>

<app-modal #aboutModal [modalConfig]="aboutConfig">
  <div class="form-row">
    <p>In Arabic, Manzoul means an ‘open community house’ where everybody is welcomed. We are inspired by the vision of
      bringing professional linguists together with clients, establishing trust, and getting the work done!</p>
    <p>Founded by Fardous Bahbouh, a chartered linguist and a researcher in translation studies, Manzoul aims to improve
      and support the language industry by streamlining the process of finding and hiring linguists to make it more
      efficient. This will allow clients to compare skills, qualifications, years of experience, and reviews of
      linguists.</p>
    <p>Manzoul helps linguists advance their careers, grow their business, and connect with trusted clients! We aim
      above all to be a hub for all linguists of all nationalities and backgrounds to do the work that they love, and
      grow their businesses. Manzoul connect language professional with more opportunities and support them to excel in
      their work. We also ensure they get paid for it.</p>
    <p>Through verified reviews, secure escrow payment system, and messaging application, Manzoul brings efficiency,
      transparency, and connectivity. We aim to elevate the standards in the translation industry which is increasingly
      depending on remote working. Manzoul also help in building trust between parties in different countries. In the
      situations where conflicts arise, we provide mitigation services.</p>
    <p>At Manzoul, we firmly believe that language services are crucial not only for global communication and economic
      development, but also for promoting social justice, equality, diversity, and inclusion. By hiring professional
      translators and interpreters, governments can guarantee speakers of other languages have access to essential
      services like medical and legal services.</p>
  </div>
</app-modal>

<app-modal #teamModal [modalConfig]="teamConfig">
  <div class="form-row">
    <div class="founder-info">
      <img src="assets\images\founder.jpg" />
      <p>
        Founded by Fardous Bahbouh, a chartered linguist and a researcher in translation studies, Manzoul aims to improve
        and support the language industry by streamlining the process of finding and hiring linguists to make it more
        efficient. This will allow clients to compare skills, qualifications, years of experience, and reviews of
        linguists.
      </p>
    </div>
    
  </div>

</app-modal>